import { render, staticRenderFns } from "./StatsCollectionTable.vue?vue&type=template&id=72bac7ef&scoped=true&"
import script from "./StatsCollectionTable.vue?vue&type=script&lang=js&"
export * from "./StatsCollectionTable.vue?vue&type=script&lang=js&"
import style0 from "./StatsCollectionTable.vue?vue&type=style&index=0&id=72bac7ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bac7ef",
  null
  
)

export default component.exports